export default __webpack_public_path__ + "static/media/explosion.min.d140d424.png";